import { useEffect } from "react";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Urgency } from "@/components/landing/Urgency";
import { Benefits } from "@/components/landing/Benefits";
import { Comparison } from "@/components/landing/Comparison";
import { Installation } from "@/components/landing/Installation";
import { Specs } from "@/components/landing/Specs";
import { UseCases } from "@/components/landing/UseCases";
import { Reviews } from "@/components/landing/Reviews";
import { Faq } from "@/components/landing/Faq";
import { Order } from "@/components/landing/Order";
import { Footer } from "@/components/landing/Footer";
import { StickyBar } from "@/components/landing/StickyBar";
import { ViewContentTracker } from "@/components/ViewContentTracker";

export default function Home() {
  useEffect(() => {
    document.title = "ClimNova – Climatiseur Midea PortaSplit 12 000 BTU en déstockage";
    if (window.location.hash) {
      setTimeout(() => document.querySelector(window.location.hash)?.scrollIntoView(), 300);
    }
  }, []);

  return (
    <div data-testid="home-page">
      <ViewContentTracker />
      <Header />
      <main>
        <Hero />
        <Urgency />
        <Benefits />
        <Comparison />
        <Installation />
        <Specs />
        <UseCases />
        <Reviews />
        <Faq />
        <Order />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}
